import { render, staticRenderFns } from "./routerView.vue?vue&type=template&id=8a9cbe6a&scoped=true"
import script from "./routerView.vue?vue&type=script&lang=js"
export * from "./routerView.vue?vue&type=script&lang=js"
import style0 from "./routerView.vue?vue&type=style&index=0&id=8a9cbe6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9cbe6a",
  null
  
)

export default component.exports